const el = {
    articlesContainer: document.querySelector('[data-component="articles-list"]'),
    skeleton: document.querySelector('.skeleton-loader'),
  }
  
  let filters = JSON.parse(el.articlesContainer.dataset.filters);
  let source = el.articlesContainer.dataset.source;
  
  
  function pagination() {
    Array.from(el.articlesContainer.querySelectorAll('[data-element="pagination-link"]')).forEach(function (element) {
  
      if (element.dataset.eventPaginate) {
        return true;
      }
  
      element.dataset.eventPaginate = true;
  
      element.addEventListener('click', function (event) {
  
        event.preventDefault();
  
        element.dataset.page == 1 ? delete filters.page : filters.page = element.dataset.page;
  
        if (element.parentNode.classList.contains('active')) {
          return true;
        }
  
        const url = constructUrl(source, filters, setUrlParameter);
        getArticles(url);
  
         scroll({ top: el.articlesContainer.offsetTop - 180, left: 0, behavior: "smooth", });
      });
    });
  }
  
  
  function getArticles(url) {
  
    el.skeleton?.classList.add('active');
  
    fetch(url, {
      method: 'GET',
      mode: "cors",
      credentials: "same-origin",
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      }
    })
      .then(response => response.json())
      .then(function (result) {
  
        el.skeleton?.classList.remove('active');
  
        if (result.html && result.html.trim() !== '') {
          el.articlesContainer.innerHTML = result.html;
  
          pagination();
  
          return true;
        }
  
        /**
         * Set an error message when the source did not return any results
         */
        return el.articlesContainer.innerHTML = 'Sorry, the list is empty at the moment';
      })
      .catch(function (error) {
        el.skeleton?.classList.remove('active');
        return error ? el.articlesContainer.innerHTML = error : el.articlesContainer.innerHTML = 'Sorry, we were unable to load the information from the source'
      });
  
  }
  
  function setUrlParameter(uri, key, value) {
  
    let index = uri.indexOf('#');
    let fragment = index === -1 ? '' : uri.substring(index);
    uri = index === -1 ? uri : uri.substring(0, index);
  
    let expression = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  
    let separator = uri.indexOf('?') !== -1 ? "&" : "?";
  
    if (uri.match(expression)) {
      uri = uri.replace(expression, '$1' + key + "=" + value + '$2');
    } else {
      uri = uri + separator + key + "=" + value;
    }
  
    return uri + fragment;
  }
  
  function constructUrl(path, filters, setURLfn) {
    /**
     * Append the filters for the fetch
     */
    if (Object.keys(filters).length) {
      Object.keys(filters).forEach(key => {
        if (key !== '_orderby') {
          path = setURLfn(path, key, filters[key]);
        }
      });
    }
  
    /**
     *  TODO - Използвайте pushState или hashchange за промяна на URL адреса при AJAX взаимодействия; 
     *  Но не и при смяна на ordering i direction
     */
  
    if (filters['_orderby']) {
      path = setURLfn(path, '_orderby', filters['_orderby'])
    } else {
      window.history.pushState({}, '', path);
    }
    
    path = setURLfn(path, 'requested_via', 'ajax');
  
    return path
  }
  
  
  document.addEventListener('DOMContentLoaded', function (e) {
  
    pagination();
  
  })
  
  // Reload page when you click back button in browser
  window.addEventListener('popstate', (e) => window.location.reload())